import React, { useEffect, useState,useContext } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useEntityCrud } from '../../hooks/useEntityCrud';
import InputMask from 'react-input-mask';
import Pagination from '../Common/Pagination';
import Swal from 'sweetalert2';
import { Context } from '../../context/UserContext';

const Index = () => {

    const context = useContext(Context);
    const { readData } = useEntityCrud('ServiceConsumer/GetAllServiceConsumer');
    const [rows, setRows] = useState([]);
    const [pages, setPages] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [pan, setPan] = useState('');
    const [rrn, setRRN] = useState('');
    const [nationalCode, setNationalCode] = useState('');
    const [consumerNationalCode, setConsumerNationalCode] = useState('');
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [showLoading, setShowLoading] = useState(false);
    const [searched, setSearched] = useState(false);


    const getData = (searchData) => {
         
        setShowLoading(true);
        const postedData = {
            offset: 0,
            limit: 10,
            ...searchData
        };
        readData(postedData).then(res => {
             
            if (res.data.status) {
                calcPages(res);
                setRows(res.data.result);
            } else {
                setRows([]);
                setPages([]);
            }
            setShowLoading(false);
        })
    }



    const calcPages = res => {
        let calcPages = res.data.count / 10;
        calcPages = calcPages > 1 ? Math.ceil(calcPages) : 1
        let pagesArray = [];
        for (let i = 1; i <= calcPages; i++)
            pagesArray.push(i);
        setPages(pagesArray);
        setCurrentPage(1);
    }

    const changePage = (e, page) => {
        e.preventDefault();
        setCurrentPage(page);
        const postedData = {
            limit: 10,
            offset: page - 1
        };
        if (fromDate)
            postedData.fromDate = parseInt(fromDate.replace(/\//g, ''));
        if (toDate)
            postedData.toDate = parseInt(toDate.replace(/\//g, ''));
        if (nationalCode)
            postedData.nationalCode = nationalCode;
        if (pan)
            postedData.pan = pan;
        if (rrn)
            postedData.rrn = rrn;
        readData(postedData).then(res => {
            setRows(res.data.result);
        }).catch(err => err.data.errors.map(error => toast.error(error.message)));
    }

    const prevPage = e => {
        e.preventDefault();
        setCurrentPage(currentPage - 1);
        const postedData = {
            limit: 10,
            offset: currentPage - 2
        };
        if (fromDate)
            postedData.fromDate = parseInt(fromDate.replace(/\//g, ''));
        if (toDate)
            postedData.toDate = parseInt(toDate.replace(/\//g, ''));
        if (nationalCode)
            postedData.nationalCode = nationalCode;
        if (pan)
            postedData.pan = pan;
        if (rrn)
            postedData.rrn = rrn;
        readData(postedData).then(res => {
            setRows(res.data.result);
        }).catch(err => err.data.errors.map(error => toast.error(error.message)));
    }

    const nextPage = e => {
        e.preventDefault();
        setCurrentPage(currentPage + 1);
        const postedData = {
            limit: 10,
            offset: currentPage
        };
        if (fromDate)
            postedData.fromDate = parseInt(fromDate.replace(/\//g, ''));
        if (toDate)
            postedData.toDate = parseInt(toDate.replace(/\//g, ''));
        if (nationalCode)
            postedData.nationalCode = nationalCode;
        if (pan)
            postedData.pan = pan;
        if (rrn)
            postedData.rrn = rrn;
        readData(postedData).then(res => {
            setRows(res.data.result);
        }).catch(err => err.data.errors.map(error => toast.error(error.message)));
    }

    const searchData = e => {
        e.preventDefault();
        const postedData = {};
        if (fromDate)
            postedData.fromDate = parseInt(fromDate.replace(/\//g, ''));
        if (toDate)
            postedData.toDate = parseInt(toDate.replace(/\//g, ''));
        if (nationalCode)
            postedData.nationalCode = nationalCode;
        if (consumerNationalCode)
            postedData.consumerNationalCode = consumerNationalCode;
        if (pan)
            postedData.pan = pan;
        if (rrn)
            postedData.rrn = rrn;
        getData(postedData);
        setSearched(true);
    }

    const clearSearch = e => {
        e.preventDefault();
        setPan('');
        setRRN('');
        setFromDate('');
        setToDate('');
        setNationalCode('');
        setSearched(false);
        setConsumerNationalCode("")
        setRows([]);
    }


    return (

        <div className="card">
            <div className="card-header"><div className="card-title">برگشت تراکنش </div></div>

            <div className="card-body">
                {showLoading ? <div className="loading-box">
                    <img src="/assets/images/loading.gif" alt="" />
                </div> : ''}

                <div  >
                    <div  >

                        <div class="alert alert-info" role="alert">
                            <button type="button" class="btn-close" data-bs-dismiss="alert" aria-hidden="true">×</button>
                            <i class="fa fa-bell-o me-2" aria-hidden="true"></i>
                          جهت انجام عملیات برگشت تراکنش ،لطفا تراکنش مورد نظر خود را جستجو کنید.
                        </div>


                        <form onSubmit={e => searchData(e)} className="row mt-4">
                            <div className="col-md-1">
                                <label>از تاریخ</label>
                                <InputMask type="tel" mask="9999/99/99" className="form-control ltr-input" value={fromDate} onChange={e => setFromDate(e.target.value)} />
                            </div>
                            <div className="col-md-1">
                                <div className="form-group">
                                    <label>تا تاریخ</label>
                                    <InputMask type="tel" mask="9999/99/99" className="form-control ltr-input" value={toDate} onChange={e => setToDate(e.target.value)} />
                                </div>
                            </div>
                            <div className="col-md-2">
                                <div className="form-group">
                                    <label>کد ملی</label>
                                    <input type="tel" className="form-control ltr-input" value={nationalCode} onChange={e => setNationalCode(e.target.value)} maxLength={10} />
                                </div>
                            </div>
                            <div className="col-md-2">
                                <div className="form-group">
                                    <label>کد ملی استفاده کننده</label>
                                    <input type="tel" className="form-control ltr-input" value={consumerNationalCode} onChange={e => setConsumerNationalCode(e.target.value)} maxLength={10} />
                                </div>
                            </div>
                            <div className="col-md-2">
                                <div className="form-group">
                                    <label>چهار رقم آخر شماره کارت</label>
                                    <input type="tel" className="form-control ltr-input" value={pan} onChange={e => setPan(e.target.value)} maxLength={4} />
                                </div>
                            </div>
                            <div className="col-md-2">
                                <div className="form-group">
                                    <label>        شماره ارجاع  </label>
                                    <input type="tel" className="form-control ltr-input" value={rrn} onChange={e => setRRN(e.target.value)} />
                                </div>
                            </div>
                            <div className="col-md-2" style={{ marginTop: 30 }}>
                                <button className="btn btn-success me-2">جستجو</button>
                                {searched ? <button className="btn btn-danger" onClick={clearSearch} type="button">بازنشانی</button> : ''}
                            </div>
                        </form>

                    </div>
                </div>


                {rows?.length !== 0 &&
                    <div className="table-responsive">
                        <table className="table table-bordered table-hover border text-nowrap text-md-nowrap">
                            <thead>
                                <tr>
                                    <th>ردیف</th>
                                    <th>نام خریدار</th>
                                    <th>عنوان کسب و کار</th>
                                    <th>مبلغ کل</th>
                                    <th>مبلغ تخفیف</th>
                                    <th>مبلغ پرداخت شده</th>
                                    <th>وضعیت پرداخت</th>
                                    <th>روش پرداخت</th>
                                    <th>شماره کارت</th>
                                    <th>تاریخ</th>
                                    <th>عملیات</th>
                                </tr>
                            </thead>
                            <tbody>
                                {rows?.map((item, index) => (
                                    <tr key={index}>
                                        <td>{(index + 1) + (currentPage > 1 ? (currentPage - 1) * 10 : '')}</td>
                                        <td>{item.personFullName}</td>
                                        <td>{item.businessTitle}</td>
                                        <td>{new Intl.NumberFormat('en-IR', { maximumSignificantDigits: 20 }).format(item.totalAmount)} ریال</td>
                                        <td>{new Intl.NumberFormat('en-IR', { maximumSignificantDigits: 20 }).format(item.totalDiscount)} ریال</td>
                                        <td>{new Intl.NumberFormat('en-IR', { maximumSignificantDigits: 20 }).format(item.totalPay)} ریال</td>
                                        <td>{item.paymentResponseCode == '00' ? <span className="badge bg-success">پرداخت شده</span> : item.paymentResponseCode == null ? <span className="badge bg-danger">پرداخت نشده</span> : <span className="badge bg-danger">ناموفق</span>}</td>
                                        <td>{item.paymentType === 1 ? <span>  اعتباری </span> : item.paymentType === 2 ? <span >  نقدی</span> : item.paymentType === 3 ? <span >  ترکیبی </span> : "-"}</td>
                                        <td dir="ltr">{item.pan}</td>
                                        <td>{(item.registerTime || '-') + ' ' + (item.registerDate == null ? '-' : (item.registerDate.toString().slice(0, 4) + '-' + item.registerDate.toString().slice(4, 6) + '-' + item.registerDate.toString().slice(6, 8)))}</td>
                                        <td>
                                            {context.checkHasPermission('read') ? <Link to={'view/' + item.serviceConsumerId} className="btn btn-icon me-1 mb-0 btn-primary">برگشت تراکنش</Link> : ''}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                        <Pagination changePage={changePage} currentPage={currentPage} pages={pages} prevPageClick={prevPage} nextPageClick={nextPage} />
                    </div>
                }
            </div>
        </div>
    );
}

export default Index;